/**
 * @typedef {'string' | "number" | 'bool'} KeyType
 */

/**
 * @param {FormData} formData - The FormData object.
 * @param {string[]} keys - An array of strings representing the keys to extract from the formData.
 * @returns {any} - An object with the keys from `keys` and their corresponding values from `formData`.
 */
export const parseFormData = (formData, keys) => {
  return keys.reduce((acc, key) => {
    const value = formData.get(key)
    if (!value) return acc
    acc[key] = value
    return acc
  }, {})
}

/**
 *
 * @param {KeyType} type
 * @param {string} value
 */
const handleKeyType = (type, value) => {
  switch (type) {
    case 'string': {
      return value
    }
    case 'number': {
      return parseInt(value)
    }
    case 'bool': {
      return value === 'true' || value === 'on'
    }
    default: {
      return value
    }
  }
}

/**
 * @param {FormData} formData - The FormData object.
 * @param {{key: string, type: KeyType}[]} keys - An array of strings representing the keys to extract from the formData.
 * @returns {any} - An object with the keys from `keys` and their corresponding values from `formData`.
 */
export const parseFormDataWithType = (formData, keys) => {
  return keys.reduce((acc, keyTypes) => {
    const value = formData.get(keyTypes.key)
    if (!value) return acc
    acc[keyTypes.key] = handleKeyType(keyTypes.type, value)
    return acc
  }, {})
}
